import React , {useEffect,useState,useRef} from 'react'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getYear,getMonth } from "date-fns";
import { useContext } from 'react'
import AuthContext from './AuthContext';
import Axios from 'axios';
import Modals from './Modals';
import Modals_Load from './Modals_Load';
import { useHistory } from "react-router-dom";
import { parse } from 'date-fns';

const FrmQEditProfile_en = ({QEdittemplate,setQEdittemplate}) => {

    const history = useHistory();
    const modalsRef = useRef(null);
    const modalsRef_load = useRef(null);
    
    const [countries, setCountries] = useState([]);
  
    const {gclang} = useContext(AuthContext);
    const {gnuserid} = useContext(AuthContext);
    const {gcusername} =  useContext(AuthContext);
    const {token,settoken} = useContext(AuthContext);

    const [Qlang,setQlang] = useState({        
    lang:gclang,
    ID_Number:gnuserid    
    });

    useEffect(() => {
 
        async function fetchData() { 

            const birthDate = new Date(QEdittemplate.Birth_Date);                   
            setStartDate(birthDate);
            
            const ID_Expiry_Date = new Date(QEdittemplate.ID_Expiry_Date);                   
            setExpiredDate(ID_Expiry_Date);
          
          modalsRef_load.current.fnshow();                      
          const response = await Axios.post('/qtargetprogram',Qlang,{                       
              'withCredentials': false,     
              headers:{
                  "x-access-token": token,              
                  'Cache-Control': 'no-cache',
                  'Pragma': 'no-cache',
                  'Expires': '0',        
                }});
              if(response.data.result === '0' || response.data.result === '-1') {            
                  modalsRef.current.fnshow('ข้อความเตือน',response.data.msg,false,true);
                        
              }
              else{    
                  
                  if(response.data.length > 0){   
                      modalsRef_load.current.fnclose();            
                      let output = response.data; 
                      //console.log('programarray',output); 
                     
                      let programArray = output.map(item => item.program); // Extract 'program' values

                      setQEdittemplate(prev => ({
                        ...prev,
                        Target_ProgramArr: programArray, // Update the state
                      }));  
                     
   
                  }
                        
              }                                                                 
      }
        async function fetchData2(){

        fetch("https://restcountries.com/v3.1/all")
        .then((res) => res.json())
        .then((data) => {
          const countryList = data
            .map((country) => ({
              name: country.name.common,
              code: country.cca2,
            }))
            .sort((a, b) => a.name.localeCompare(b.name)); // Sort A-Z
            setCountries(countryList);
          })
          .catch((error) => console.error("Error:", error));
    
    
      }
           
               
        fetchData();   
        fetchData2();   
        
    
    }, [token]); 
    

    const fn_range = (start, end, step = 1) => {
        const output = [];
        for (let i = start; i < end; i += step) {
          output.push(i);
        }
        return output;
    };

      const [startDate, setStartDate] = useState(new Date());
      const [expiredDate, setExpiredDate] = useState(new Date());
      
      const years = fn_range(1750, getYear(new Date()) + 50, 1);  
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
    
      const renderCustomHeader = (date, changeYear, changeMonth) => (
        <div
          style={{
            margin: 10,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <select
            value={getYear(date)}
            onChange={({ target: { value } }) => changeYear(Number(value))}
          >
            {years.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
    
          <select
            value={months[getMonth(date)]}
            onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}
          >
            {months.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
      );
      
 
  const handleAddChange = async (e) =>{
    e.preventDefault();
          
    const fieldName = e.target.getAttribute('name');
    const fieldValue = e.target.value;
    
    const newQEdittemplate = {...QEdittemplate }; 
    newQEdittemplate[fieldName] = fieldValue;
    
    setQEdittemplate(newQEdittemplate);
              
  }


  const handleselsexchange = async (e) =>{
    
    e.preventDefault();  
    
    const newQEdittemplate = {...QEdittemplate }; 
    newQEdittemplate["Sex"] = e.target.value;
    setQEdittemplate(newQEdittemplate);
   
  }


  const handleselID_Issue_Placechange = async (e) =>{
    
    e.preventDefault();  
    
    const newQEdittemplate = {...QEdittemplate }; 
    newQEdittemplate["ID_Issue_Place"] = e.target.value;
    setQEdittemplate(newQEdittemplate);
   
  }

  
  const handleselleadnamechange = async (e) =>{
    
    e.preventDefault();  
    
    const newQEdittemplate = {...QEdittemplate }; 
    newQEdittemplate["LeadName"] = e.target.value;
    setQEdittemplate(newQEdittemplate);
   
  }

  const fncallback = (e,iserror) => {
    e.preventDefault(); 
    if(iserror === true)
    {
      modalsRef.current.fnclose();                                    
      history.push('/login');
    }
    else{
      modalsRef.current.fnclose();        
      //modalsRef.current.fnshow('Output','กรุณากรอกข้อมูลก่อนครับ',false,false,"1");                             
    }
    
  }
  

  const handleUpdateChange2 = (date) => {
    if (date) {
      const clonedDate = new Date(date.getTime());
  
      // Convert the date to UTC and format it as 'YYYY-MM-DD' for consistency
      const formattedBirthDate = new Date(Date.UTC(
        clonedDate.getFullYear(),
        clonedDate.getMonth(),
        clonedDate.getDate()
      ));
  
      // Set cloned date for DatePicker
      setStartDate(formattedBirthDate);
  
      // Directly set the formatted date in the state (no need to parse it again)
      setQEdittemplate((prev) => ({
        ...prev,
        Birth_Date: formattedBirthDate.toISOString(), // Send the UTC date as an ISO string
      }));
    }
  };

  const handleUpdateChange3 = (date) => {
    if (date) {
      const clonedDate = new Date(date.getTime());  
      // Convert the date to UTC and format it as 'YYYY-MM-DD' for consistency
      const formattedExpiredDate = new Date(Date.UTC(
        clonedDate.getFullYear(),
        clonedDate.getMonth(),
        clonedDate.getDate()
      ));
  
      // Set cloned date for DatePicker
      setExpiredDate(formattedExpiredDate); // Set cloned date for DatePicker
  
      // Directly set the formatted date in the state (no need to parse it again)
      setQEdittemplate((prev) => ({
        ...prev,
        ID_Expiry_Date: formattedExpiredDate.toISOString(), // Send the UTC date as an ISO string
      }));
    }
      
  };

  const handleselprogramarrchange = async (e) =>{

    e.preventDefault();
    setQEdittemplate(prevState => ({
      ...prevState,
      Target_Program: e.target.value,
    }));

  }

  
  return (
    <>
        <Modals_Load ref={modalsRef_load} />
        <Modals lctitle='' lcbody='' fullscreen='false' fncallback={fncallback} ref={modalsRef} />
        <br></br> 
        <div class="container mt-5">
          <h4 class="text-center mb-4"><b>CUBEST Chulalongkorn University Business Evaluation School Test</b></h4>          
          <h4 class="text-center mb-4">CUBEST ENGLISH Program REF: {QEdittemplate.CUBEST}</h4>
          <form autocomplete="off" class="shadow p-4 rounded bg-light">
                                    
            <div className="mb-4 row">
              <label htmlFor="staticEmail" className="col-auto col-form-label text-primary"><b>ID/Passport No:</b></label>
              <div className="col">
                <input 
                  type="text" 
                  readOnly 
                  className="form-control-plaintext" 
                  id="ID_Number" 
                  name="ID_Number" 
                  value={QEdittemplate.ID_Number}
                />
              </div>
            </div>


            <div class="mb-4">
              <label for="staticPrefaceName" class="form-label"><b>Title</b></label>            
              <select className="form-select" name="LeadName" id="LeadName"  value={QEdittemplate.LeadName} onChange={handleselleadnamechange} >  
                  <option value=''>Please Select</option>
                  <option value='Mr.'>Mr.</option>
                  <option value='Ms.'>Ms.</option>
                  <option value='Mrs.'>Mrs.</option>                                    
              </select>               
            </div>

          
            <div class="mb-4">
              <label for="staticname_eng" class="form-label"><b>First Name (English)</b></label>
              <input type="text" class="form-control" id="First_Name_Eng"name="First_Name_Eng" value={QEdittemplate.First_Name_Eng} onChange={handleAddChange} />                          
            </div>

            <div class="mb-4">
              <label for="staticlastname_eng" class="form-label"><b>Last Name (English)</b></label>            
              <input type="text" class="form-control" id="Last_Name_Eng" name="Last_Name_Eng" value={QEdittemplate.Last_Name_Eng} onChange={handleAddChange} />            
            </div>

            <div class="mb-4">
              <label for="staticName" class="form-label"><b>First Name (Thai If Any)</b></label>
              <input type="text" class="form-control" id="First_Name_Thai" name="First_Name_Thai" value={QEdittemplate.First_Name_Thai} onChange={handleAddChange} />            
            </div>

            <div class="mb-4">
              <label for="staticLastName" class="form-label"><b>Last Name (Thai If Any)</b></label>            
              <input type="text" class="form-control" id="Last_Name_Thai" name ="Last_Name_Thai" value={QEdittemplate.Last_Name_Thai} onChange={handleAddChange} />            
            </div>

            <div class="mb-4">
            <label for="staticbirthdate" class="form-label"><b>Birth Date (DD/MM/YYYY)&nbsp;&nbsp;</b></label>                                                             
                <DatePicker
                renderCustomHeader={({ date, changeYear, changeMonth }) =>
                    renderCustomHeader(date, changeYear, changeMonth)
                }
                selected={startDate}
                onChange={handleUpdateChange2}
                dateFormat="dd/MM/yyyy"
                id="Birth_Date"
                name="Birth_Date"
                />           
            </div>


            <div class="mb-4">
            <label for="staticSex" class="form-label"><b>Sex</b>&nbsp;&nbsp;</label>
            
                <select className="form-select" name="Sex" id="Sex" value={QEdittemplate.Sex} onChange={handleselsexchange} >         
                <option value=''>Please Select</option>
                <option value='M'>M</option>
                <option value='F'>F</option>              
                </select>   
            
            </div>


            <div class="mb-4">
              <label for="staticSex" class="form-label"><b>ID Issuing Place</b></label>              
              <select className="form-select" name="ID_Issue_Place" id="ID_Issue_Place" value={QEdittemplate.ID_Issue_Place} onChange={handleselID_Issue_Placechange} >                       
                <option value=""></option>
                {countries.map((country) => (
                  <option value={country.name}>
                    {country.name}
                  </option>
                ))}
              </select>              
            </div>


            <div class="mb-4">
            <label for="staticExpireddate" class="form-label"><b>ID Expiry Date (DD/MM/YYYY)&nbsp;&nbsp;</b></label>           
               
                <DatePicker
                renderCustomHeader={({ date, changeYear, changeMonth }) =>
                    renderCustomHeader(date, changeYear, changeMonth)
                }
                selected={expiredDate}
                onChange={handleUpdateChange3}
                dateFormat="dd/MM/yyyy"
                id="ID_Expiry_Date"
                name="ID_Expiry_Date"
                />
           
            </div> 

            <div class="mb-4">
            <label for="staticEmail" class="form-label"><b>Email</b></label>            
                <input type="email" class="form-control" id="Email" name="Email" value={QEdittemplate.Email} onChange={handleAddChange} />                            
            </div>     
            
            <div class="mb-4">      
              <label for="Target_ProgramArr" class="form-label"><b>Apply for using in the program</b></label>                   
              
                <select
                  className="form-select"
                  name="Target_ProgramArr"
                  id="Target_ProgramArr"
                  value={QEdittemplate.Target_Program}
                  onChange={handleselprogramarrchange}
                >
                  <option value=''>Please Select</option>
                  {QEdittemplate.Target_ProgramArr.map(program => (
                    <option key={program} value={program}>
                      {program}
                    </option>
                  ))}
               </select>              
            </div>
  

            <div class="mb-4">
            <label for="staticAddress" class="form-label"><b>Address for sending test result</b></label>            
            <textarea class="form-control" id="Address1" name="Address1" rows="4" value={QEdittemplate.Address1} onChange={handleAddChange}></textarea>              
            
            </div>


            <div class="mb-4">
              <label for="statictelephone" class="col-sm-2 col-form-label"><b>Telephone</b></label>            
              <input type="text" class="form-control" id="Telephone" name="Telephone" value={QEdittemplate.Telephone} onChange={handleAddChange} />                          
            </div>

            <div class="mb-4">
              <label for="staticmobilephone" class="col-sm-2 col-form-label"><b>Mobile Phone</b></label>
              <input type="text" class="form-control" id="MobilePhone" name="MobilePhone" value={QEdittemplate.MobilePhone} onChange={handleAddChange} />            
            </div>
                            
          </form>
      </div>
      
     
        
    </>
  )
}



export default FrmQEditProfile_en